import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.resize()
  }

  resize() {
    const textarea = this.inputTarget
    textarea.style.height = "auto"
    textarea.style.height = `${textarea.scrollHeight}px`
  }

  handleKeydown(event) {
    if (event.key !== "Enter" || event.shiftKey) return

    event.preventDefault()
    const textarea = this.inputTarget
    if (!textarea.value.trim()) return

    // requestSubmit allows Rails UJS/Turbo to hook into the submission
    this.element.requestSubmit()
  }
}
